import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UpdatePassword } from './models/password.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Subject, of } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['../login.component.scss', './change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  public slides: Array<{ [key: string]: string }>;
  public errmsg: string = '';
  public user: any;
  public updatePasswordFromEmail: boolean = false;

  get credentials() {
    return this.loginService.credentials;
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService,
    private loginService: LoginService
  ) {
    this.slides = [
      { image: '/assets/img/login/2.png', text: 'Second Slide' },
      { image: '/assets/img/login/1.png', text: 'First Slide' },
    ];
  }

  ngOnInit(): void {
    if (!this.loginService.getPrivateToken()) {
      this.toastrService.error('User unidentified', 'Authentication');
      this.router.navigate(['/forgot']);
    }

    this.updatePasswordFromEmail = JSON.parse(localStorage.getItem('user'))?.actions?.up;
  }

  private paramsOk(): boolean {
    this.errmsg = '';
    // The password must be at least 15 characters long
    // The password must contain mix of at least three of following: uppercase, lowercase, number and special characters
    const lengthRegex = /^.{15,}$/;
    const charRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).*$/;
    const allFilledUp =
      this.credentials.otpToken.length && this.credentials.password.length && this.credentials.password2.length;
    const passwordsMatch = this.credentials.password === this.credentials.password2;
    if (!allFilledUp) {
      this.errmsg = 'All fields must be filled.';
      return false;
    }
    if (!passwordsMatch) {
      this.errmsg = 'Passwords do not match.';
      return false;
    }
    if (!lengthRegex.test(this.credentials.password)) {
      this.errmsg = 'The password must be at least 15 characters long.';
      return false;
    }
    if (!charRegex.test(this.credentials.password)) {
      this.errmsg =
        'The password must contain mix of at least three of following: uppercase, lowercase, number and special characters.';
      return false;
    }

    return true;
  }

  public update() {
    if (!this.paramsOk()) return;

    this.authService
      .updatepassword(this.credentials)
      .pipe(
        tap(() => this.toastrService.success('Password updated.', 'Authentication')),
        tap(() => this.router.navigate(['/login'])),
        catchError(error => {
          if (error.error && error.error.Error) {
            this.errmsg = error.error.Error;
          }
          //this.router.navigate(['/login']);
          this.toastrService.error(error.message, 'Authentication');
          return EMPTY;
        }),
        take(1)
      )
      .subscribe();
  }
}
